// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Gz-z","giftOrPromoSelector":"Hz-z","disabled":"Iz-z","subTitle":"Jz-z","selectShipAddressMessage":"Kz-z","changePayment":"Lz-z"};